// Where a purchase actually happens.
//
// Payment is taken on an external checkout, not on this site. The link is an
// edushrt.com short link that forwards to the shop's checkout. The product
// and the affiliate attribution live inside the short link's destination, so
// this address must be used verbatim: no query string appended, no path
// "tidied", no trailing slash added. Any of those breaks the redirect, and the
// failure is invisible from this side.
//
// It replaced the old shop's direct add-to-cart URL. That old address must not
// come back anywhere on the site (checkoutWiring.test.ts enforces it).
//
// Every buy button on the site goes through CheckoutButton, which reads this
// constant, so when the checkout changes again, this is the single line to
// edit.
export const CHECKOUT_URL = "https://edushrt.com/RBoIEp5H";

/**
 * Send the browser to the checkout from code, for the paths that decide where
 * to go rather than rendering a link (CourseOverview's enroll handler).
 *
 * Deliberately a full navigation, not react-router's navigate(): the target is
 * another origin, and handing an absolute URL to the router would resolve it
 * as an in-app path and land on our own 404 instead of the shop.
 */
export function goToCheckout(): void {
  window.location.href = CHECKOUT_URL;
}
